<div class="tw-px-6 tw-pt-10 tw-pb-8 tw-relative">
  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-w-8 tw-h-8 tw-top-4 tw-right-4 tw-bg-[#F3F3F3] tw-rounded-full" (click)="closeBottomSheet()">
    <div class="tw-flex tw-items-center tw-justify-center tw-w-[13px] tw-h-[13px] tw-text-400 tw-leading-4 tw-text-gray-500 tw-font-bold">&#10005;</div>
  </div>

  <div>
    <p class="tw-capitalize tw-mb-3 tw-font-lexend tw-font-bold tw-text-gray-800 tw-text-400" i18n="@@priceDetail">Price Detail</p>
    @if (data.type === appConfig.Shared.priceDetailsBottomsheetType.REGIMEN_REORDER) {
      <ng-container [ngTemplateOutlet]="regimenReorderTemplate" [ngTemplateOutletContext]="regimenReorderTemplateContext"></ng-container>
    } @else {
      <ng-container [ngTemplateOutlet]="regimenTemplate" [ngTemplateOutletContext]="regimenTemplateContext"></ng-container>
    }
  </div>
</div>


<ng-template #regimenReorderTemplate let-data>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-flex tw-items-center tw-justify-between">
      @if (isHairRegimen) {
        <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@completeHairKit">
          Complete Hair Kit ({{data.regimenDetails.products.length}} products)
        </p>
      } @else {
        <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@completeSkinKit">
          Complete Skin Kit ({{data.regimenDetails.products.length}} products)
        </p>
      }
      <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-gray-500">₹{{productsTotalMrp}}</p>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between">
      <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@discount">Discount</p>
      <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-orange-500">- ₹{{originalDiscount}}</p>
    </div>
    @if (cashUsed > 0) {
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500 tw-flex tw-items-center tw-gap-1">
          <span i18n="@@cureskinCash">Cureskin Cash</span>
          <img class="tw-w-4 tw-h-4" src="/assets/images/cureskin-cash-icon.png" />
        </p>
        <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-orange-500">- ₹{{cashUsed}}</p>
      </div>
    }
    @if (data.showDoctorCharges) {
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@doctorCharges2Checkups">Doctor Charges (2 check-ups)</p>
        <div class="tw-flex tw-items-center tw-gap-[6px]">
          <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-gray-500 tw-line-through">₹{{DOCTOR_CHARGES_AMOUNT}}</p>
          <span class="tw-bg-orange-500 tw-text-white tw-text-[10px] tw-font-body tw-font-medium tw-leading-5 tw-px-[6px] tw-rounded tw-uppercase" i18n="@@free">free</span>
        </div>
      </div>
    } @else {
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-text-300 tw-leading-[28px] tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@delivery">Delivery</p>
        <div class="tw-flex tw-items-center tw-gap-[6px]">
          <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-gray-500 tw-line-through">₹200</p>
          <span class="tw-bg-orange-500 tw-text-white tw-text-[10px] tw-font-body tw-font-medium tw-leading-5 tw-px-[6px] tw-rounded tw-uppercase" i18n="@@free">free</span>
        </div>
      </div>
    }
  </div>
  <div class="tw-my-3 tw-h-[1px] tw-w-full tw-bg-[repeating-linear-gradient(to_right,#CFCFCF_0,#CFCFCF_5px,transparent_5px,transparent_11px)]"></div>
  <div class="tw-flex tw-items-center tw-justify-between tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800">
    <p class="tw-capitalize" i18n="@@toPay">To pay</p>
    <p>₹{{data.regimenDetails.totalSP}}</p>
  </div>
</ng-template>


<ng-template #regimenTemplate let-data>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-flex tw-items-center tw-justify-between">
      <p class="tw-text-300 tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@treatmentPlan">Treatment Plan</p>
      <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-gray-500">₹{{data.fixedPriceMrp}}</p>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between">
      <p class="tw-text-300 tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@discount">Discount</p>
      <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-orange-500">- ₹{{discount}}</p>
    </div>
    @if (crossSellDiscount > 0) {
      <div class="tw-flex tw-items-center tw-justify-between">
        <p class="tw-text-300 tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@limitedTimeDiscount">Limited-Time Discount</p>
        <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-orange-500">- ₹{{crossSellDiscount}}</p>
      </div>
    }
    <!-- TODO: Delivery amount should be fetched from experiment -->
    <div class="tw-flex tw-items-center tw-justify-between">
      <p class="tw-text-300 tw-font-lexend tw-font-normal tw-text-gray-500" i18n="@@delivery">Delivery</p>
      <div class="tw-flex tw-items-center tw-gap-[6px]">
        <p class="tw-text-200 tw-leading-[18px] tw-font-body tw-font-medium tw-text-gray-500 tw-line-through">₹200</p>
        <span class="tw-bg-orange-500 tw-text-white tw-text-[10px] tw-font-body tw-font-medium tw-leading-5 tw-px-[6px] tw-rounded tw-uppercase" i18n="@@free">free</span>
      </div>
    </div>
  </div>
  <div class="tw-my-3 tw-h-[1px] tw-w-full tw-bg-[repeating-linear-gradient(to_right,#CFCFCF_0,#CFCFCF_5px,transparent_5px,transparent_11px)]"></div>
  <div class="tw-flex tw-items-center tw-justify-between tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800">
    <p class="tw-capitalize" i18n="@@toPay">To pay</p>
    <p>₹{{data.fixedPrice}}</p>
  </div>
</ng-template>
